import BaseDialog from '@components/shared/Dialog/BaseDialog';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import * as React from 'react';
import { Breakpoint } from '@mui/material'; // TODO: Import from ui kit
import AdminContainer from '@containers/AdminContainer';

const DOWNLOAD_BUTTON_WIDTH = 180;
const DEFAULT_GROUP = '';

export type DownloadModalProps = {
  title: string;
  contentHeader: string;
  contentDescription: string;
  renderOpener?: (onClick: () => void) => React.ReactNode;
  onClose?: () => void;
  onOpen?: () => void;
  isOpen?: boolean;
  footer?: React.ReactNode;
  maxWidth?: Breakpoint;
  downloadOptions: {
    name: string;
    label?: string;
    description?: string;
    onClick?: () => void;
    component?: React.ReactNode;
    internal?: boolean;
    group?: string;
    hidden?: boolean;
  }[];
};

const DownloadModal = (props: DownloadModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const groupedDownloadOptions = props.downloadOptions.reduce<
    Record<string, typeof props.downloadOptions>
  >((acc, option) => {
    if (option.hidden) return acc;

    const group = option.group ?? DEFAULT_GROUP;

    return {
      ...acc,
      [group]: [...(acc[group] ?? []), option],
    };
  }, {});

  return (
    <>
      {props.renderOpener?.(() => {
        setIsOpen(true);
        props.onOpen?.();
      })}
      <BaseDialog
        open={!!(isOpen || props.isOpen)}
        title={props.title}
        onClose={() => {
          setIsOpen(false);
          props.onClose?.();
        }}
        maxWidth={props.maxWidth}
      >
        <Stack spacing={1} padding={1}>
          <Typography textAlign="center" sx={{ fontWeight: 'bold' }}>
            {props.contentHeader}
          </Typography>
          <Typography textAlign="center">{props.contentDescription}</Typography>

          <Stack direction="column" gap="2rem">
            {Object.entries(groupedDownloadOptions).map(([group, options]) => {
              return (
                <Stack
                  direction="column"
                  gap="0.5rem"
                  key={group}
                  alignItems="center"
                >
                  <Typography fontWeight="bold">{group}</Typography>
                  <Stack
                    gap="0.5rem"
                    direction="row"
                    alignItems="center"
                    sx={{ '> button': { minWidth: DOWNLOAD_BUTTON_WIDTH } }}
                  >
                    {options.map(option => {
                      const Container = option.internal
                        ? AdminContainer
                        : React.Fragment;

                      const containerProps = option.internal
                        ? { allowInternal: true }
                        : {};

                      return (
                        <Container key={option.name} {...containerProps}>
                          <Box>
                            {option.component ?? (
                              <Button onClick={option.onClick} size="large">
                                {option.label}
                              </Button>
                            )}
                            <Typography>{option.description}</Typography>
                          </Box>
                        </Container>
                      );
                    })}
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
        </Stack>
        {props.footer}
      </BaseDialog>
    </>
  );
};

export default DownloadModal;
